import {OBJECT_TYPES_KEY} from "~/types/cached_keys";
import type {IObjectType, JsonDataResponse} from "~/types/types";
import {OBJECT_TYPE_API} from "~/routes/ari_routes";
import {api_header} from "~/types/api_header";
import {showErrorToast} from "~/types/helpers";

export default async function () {
    const groupTypes = ref<IObjectType[]>([])

    const {data: cached } = useNuxtData(OBJECT_TYPES_KEY)

    if (cached.value?.data != undefined) {
        groupTypes.value = cached.value.data
    } else {
        const cfg = useRuntimeConfig()

        const {data} = await
            useFetch<JsonDataResponse<IObjectType[]>>(OBJECT_TYPE_API, {
                baseURL: String(useNuxtApp().$apiUrl()),
                headers: api_header(),
                key: OBJECT_TYPES_KEY
            })

        if (data.value?.status)
            groupTypes.value = data.value.data
        else
            showErrorToast(data.value?.error)
    }

    return {
        objectTypes: groupTypes
    }
}